import { z } from 'zod'
import { api } from 'api/api'

const shouldUseBillRateRequestSchema = z.object({
  companyId: z.number(),
  positionId: z.number(),
})

export type ShouldUseBillRateRequest = z.infer<
  typeof shouldUseBillRateRequestSchema
>

const shouldUseBillRateResponseSchema = z
  .object({
    is_bill_pay: z.boolean().optional(),
    isBillPay: z.boolean().optional(),
    blockShiftCreation: z.boolean().optional(),
  })
  .transform((data) => ({
    // Temporarily backwards compatible with old API response
    isBillPay: data.isBillPay ?? data.is_bill_pay ?? false,
    blockShiftCreation: data.blockShiftCreation ?? false,
  }))

export type ShouldUseBillRateResponse = z.infer<
  typeof shouldUseBillRateResponseSchema
>

export async function getShouldUseBillRate(request: ShouldUseBillRateRequest) {
  const { companyId, positionId } =
    shouldUseBillRateRequestSchema.parse(request)
  const response = await api.get(
    `/company/${companyId}/position/${positionId}/is_bill_pay`
  )
  return shouldUseBillRateResponseSchema.parse(response.data)
}
